import { HelperText, Icon, Input, Text } from '@ui-component-library';

import { useCheckout } from '../context/CheckoutContext';

const COUPON_APPLY_DEBOUNCE_MS = 400;

export const CouponInput = () => {
  const { couponDiscount, onCouponApply, onCouponRemove, couponError } = useCheckout();
  const handleChange = (value: string) => {
    if (!value) {
      onCouponRemove?.();
      return;
    }
    if (value.length <= 3) {
      return;
    }

    onCouponApply?.(value);
  };

  return (
    <div className="flex w-full flex-col gap-2">
      <div className="flex w-full flex-col gap-4">
        <Text variant="text-base/leading-normal/medium" className="pl-4">
          Lägg till rabattkod
        </Text>
        <div>
          {couponDiscount ? (
            <div className="bg-white-50 flex h-14 flex-row items-center justify-between gap-2 rounded-xl p-4">
              <div
                className="bg-cloud-300 hover:bg-cloud-500 flex w-auto cursor-pointer items-center justify-center gap-1 rounded-xs px-2 py-1"
                onClick={onCouponRemove}
              >
                <Text variant="text-xs/leading-normal/medium">{couponDiscount.coupon_code}</Text>
                <Icon name="CrossSimple" size="medium" />
              </div>
              <Text variant="text-xs/leading-normal/medium">{couponDiscount.label}</Text>
            </div>
          ) : (
            <Input
              name="coupon-code"
              type="text"
              variant="fluid"
              label="Ange rabattkod"
              className="w-full"
              debounceDelay={COUPON_APPLY_DEBOUNCE_MS}
              onChange={handleChange}
            />
          )}
        </div>
      </div>
      {couponError && (
        <HelperText
          icon="ExclamationFilled"
          label={couponError}
          className="fill-danger-500 text-danger-500 pl-4"
        >
          {couponError}
        </HelperText>
      )}
    </div>
  );
};
